export const getBooleanFromValue = (value?: string | number | boolean): boolean =>
  value === true || ['1', 'true'].includes(`${value}`) ? true : false;
